export default {
    namespaced: true,
    state: {
        sidebarMode: "filters",
        isDimensionResponsive: false,
        visibleSideBar: true,
        sidebarHidden: false
    },
    mutations: {
        showSidebar(state) {
            state.visibleSideBar = true;
        },
        hideSidebar(state) {
            state.visibleSideBar = false;
        },
        setIsDimensionResponsive(state, payload) {
            state.isDimensionResponsive = payload;
        },
        setHiddenSidebar(state, payload){
            state.sidebarHidden = payload;
        },
        toggleSidebar(state) {
            state.visibleSideBar = !state.visibleSideBar;
        },
        setSidebarMode(state, mode) {
            state.sidebarMode = mode;
        }
    },
    actions: {
        hideSidebar(context) {
            context.commit("hideSidebar");
        },
        showSidebar(context) {
            context.commit("showSidebar");
        },
        setSidebarModeFilters(context) {
            context.commit("setSidebarMode", "filters");
        },
        setSidebarModeResults(context) {
            context.commit("setSidebarMode", "results");
        }
    },
    getters: {
        isVisibleSideBar(state) {
            return state.visibleSideBar == true;
        },
        isDimensionResponsive(state) {
            return state.isDimensionResponsive == true;
        },
        isSidebarHidden(state){
            return state.sidebarHidden == true;
        }
    }
}